import { Link } from 'react-router-dom';
import Logo from './Logo';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-gray-100 py-10 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <Link to="/">
            <Logo size="small" />
          </Link>

          <nav className="flex flex-wrap items-center justify-center gap-6">
            <Link to="/about" className="text-sm text-gray-500 hover:text-brand-600 transition-colors">About</Link>
            <Link to="/blog" className="text-sm text-gray-500 hover:text-brand-600 transition-colors">Blog</Link>
            <Link to="/privacy" className="text-sm text-gray-500 hover:text-brand-600 transition-colors">Privacy</Link>
            <Link to="/support" className="text-sm text-gray-500 hover:text-brand-600 transition-colors">Support</Link>
            <a href="mailto:info@pixelutility.com" className="text-sm text-gray-500 hover:text-brand-600 transition-colors">Contact</a>
          </nav>

          <p className="text-xs text-gray-400">
            &copy; {currentYear} PixelUtility. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
